import { useEffect, useState } from "react";
import { getAllConnectionKeysWithoutId } from "../services/connectionKeysService";

const useFetchAllConnectionKeyWithoutId = ({ setIsLoading }: any) => {
  const [connectionKeysData, setConnectionKeysData] = useState<any[]>([]);
  useEffect(() => {
    const getConnectionKeysData = async () => {
      setIsLoading(true);
      try {
        const result = await getAllConnectionKeysWithoutId();
        setConnectionKeysData(result);
      } catch (err) {
        setConnectionKeysData([]);
      } finally {
        setIsLoading(false);
      }
    };
    getConnectionKeysData();
  }, []);

  return [connectionKeysData];
};

export default useFetchAllConnectionKeyWithoutId;
